import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextArea } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function PlayItOutGatherPage() {
  const [museum, setMuseum] = useState('');
  const [stories, setStories] = useState('');
  const [patterns, setPatterns] = useState('');

  return (
    <TaskPage
      phase="gather"
      title="Play It Out (Artifact Museum)"
      pageNumber={6}
      instruction="Turn the room (or virtual board) into a mini museum of our best options. Build (3-5 min): each person pins 1-3 capsule cards they're proud of. Story (pairs, 2 min each): walk a partner through your card (what/why/evidence). Reflect (team, 3-5 min): what patterns or gaps do we see? What evidence types are missing?"
      whyItMatters="The build → story → reflect cycle increases engagement, surfaces tacit knowledge, and boosts recall."
      coachRail={{
        timing: "10-15 minutes",
        tips: "Build silently first, then share. Use physical or digital cards if possible.",
        debrief: "What patterns emerged? What evidence types are missing?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Build: Museum (3-5 min)</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">Each person pins 1-3 capsule cards they're proud of.</p>
          <TextArea
            label="What cards did you pin?"
            value={museum}
            onChange={(e) => setMuseum(e.target.value)}
            placeholder="List the items you selected and why..."
            rows={6}
          />
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Story: Walk Through (Pairs, 2 min each)</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">Walk a partner through your card (what/why/evidence).</p>
          <TextArea
            label="Key stories from your cards"
            value={stories}
            onChange={(e) => setStories(e.target.value)}
            placeholder="What did you explain? What did you learn from others?"
            rows={5}
          />
        </div>

        <div className="bg-[var(--green-dim)] border border-[var(--green)] p-6">
          <h3 className="text-lg font-semibold text-[var(--green)] dark:text-[var(--text-ter)] mb-4">Reflect: Patterns & Gaps (Team, 3-5 min)</h3>
          <p className="text-sm text-[var(--green)] dark:text-[var(--text-ter)] mb-4">What patterns or gaps do we see? What evidence types are missing?</p>
          <TextArea
            label="Reflection notes"
            value={patterns}
            onChange={(e) => setPatterns(e.target.value)}
            placeholder="What patterns emerged? What evidence types are missing? What gaps did we discover?"
            rows={5}
          />
        </div>

        <Callout type="tip" phase="gather">
          <p className="text-sm">This works best in person or with virtual whiteboards. Use physical or digital cards to visualize the options.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






